export const assetsConfiguration = {
	sources: ['Lightroom', 'CreativeCloud'],
	clientInfo: {
		clientVersion: '1.1.0',
		clientId: 'CCHomeRecent',
		surface: 'CCWeb',
	},
	limit: 5,
	rendition: {
		size: {
			default: {
				image: 240,
			},
		},
	},
};
